export function equalWithinEpsilon(a: number, b: number, epsilon = 0.001): boolean {
    return Math.abs(a - b) < epsilon;
}
export function greaterThanOrEqualWithinEpsilon(a: number, b: number, epsilon = 0.001): boolean {
    return a >= b || equalWithinEpsilon(a, b, epsilon);
}

export function lessThanOrEqualWithinEpsilon(a: number, b: number, epsilon = 0.001): boolean {
    return a <= b || equalWithinEpsilon(a, b, epsilon);
}

export function lessThanWithinEpsilon(a: number, b: number, epsilon = 0.001): boolean {
    return a < b - epsilon;
}

export function greaterThanWithinEpsilon(a: number, b: number, epsilon = 0.001): boolean {
    return a > b + epsilon;
}
